
import { Component, Vue } from "vue-property-decorator";

interface SectionBlock {
    title: string;
    lines: string[];
    type?: "list";
}

interface NetworkSection {
    title: string;
    blocks: SectionBlock[];
}

const cesfamRequirements = [
    "Llega con anticipación a tu cita.",
    "Anúnciate en el tótem e indica tu sector y RUT.",
    "Presenta tu cédula de identidad para recibir atención y para el retiro de alimentos o medicamentos."
];

const cecosfRequirements = [
    "Llega con anticipación a tu cita.",
    "Anúnciate en SOME.",
    "Presenta tu cédula de identidad para recibir atención y para el retiro de alimentos o medicamentos."
];

const requestBlocks: SectionBlock[] = [
    {
        title: "SOLICITA TU ATENCIÓN DE SALUD A TRAVÉS DE:",
        lines: []
    },
    {
        title: ">> Telesalud",
        lines: ["Ingresa y completa el formulario en:", "https://telesalud.gob.cl/solicitud"]
    },
    {
        title: ">> Presencial",
        lines: [
            "Disponible solo para algunas prestaciones y grupos prioritarios, según indicación previa del equipo de salud.",
            "Más información en",
            "www.maipusalud.cl/solicita-tu-atencion-de-salud"
        ]
    }
];

function requirementsBlock(lines: string[]): SectionBlock {
    return {
        title: "REQUISITOS A TU LLEGADA AL CESFAM",
        lines,
        type: "list"
    };
}

function withCesfamInfo(blocks: SectionBlock[]): SectionBlock[] {
    return [...blocks, requirementsBlock(cesfamRequirements), ...requestBlocks];
}

function withCecosfInfo(blocks: SectionBlock[]): SectionBlock[] {
    return [...blocks, requirementsBlock(cecosfRequirements), ...requestBlocks];
}

@Component
export default class NewNuestraRed extends Vue {
    private sections: NetworkSection[] = [
        {
            title: "DIRECCIÓN DE SALUD",
            blocks: [
                { title: "Directora", lines: ["Patricia Castillo Navarro", "Profesión: Matrona."] },
                { title: "Dirección", lines: ["Av. General Ordoñez N° 176, Maipú"] },
                { title: "Contacto", lines: ["Call Center: 22 677 6078"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves de 08:00 a 17:00 hrs.", "Viernes de 08:00 a 16:00 hrs."]
                }
            ]
        },
        {
            title: "CESFAM Pdta. Michelle Bachelet Jeria",
            blocks: withCesfamInfo([
                { title: "Directora", lines: ["Mariela González Moraga", "Matrona"] },
                { title: "Dirección", lines: ["Av. Nueva San Martín N° 779, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 6825"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a jueves: 08:00 a 17:00 hrs.", "Viernes: 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la atención",
                    lines: [
                        "Lunes a jueves: 17:00 a 20:00 hrs.",
                        "Viernes: 16:00 a 20:00 hrs.",
                        "Sábado: 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CESFAM Dr. Luis Ferrada Urzúa",
            blocks: withCesfamInfo([
                { title: "Director", lines: ["Alexis Ahumada Salinas", "Cirujano Dentista"] },
                { title: "Dirección", lines: ["Tierra Fértil N° 5161, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 6935"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a jueves: 08:00 a 17:00 hrs.", "Viernes: 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la atención",
                    lines: [
                        "Lunes a jueves: 17:00 a 20:00 hrs.",
                        "Viernes: 16:00 a 20:00 hrs.",
                        "Sábado: 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CESFAM Clotario Blest Riffo",
            blocks: withCesfamInfo([
                { title: "Director", lines: ["José Arenas Villarreal.", "Cirujano Dentista."] },
                { title: "Dirección", lines: ["Los Trabajadores N° 999, Maipú."] },
                {
                    title: "Contacto",
                    lines: ["Teléfono OIRS: 22 677 6168 / 22 677 6644", "oirscesfamclotarioblest@gmail.cl"]
                },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves de 08:00 a 17:00 hrs.", "Viernes de 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la Atención",
                    lines: [
                        "Lunes a Jueves de 17:00 a 20:00 hrs",
                        "Viernes de 16:00 a 20:00 hrs.",
                        "Sábados de 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CESFAM Dr. Carlos Godoy Lagarrigue",
            blocks: withCesfamInfo([
                { title: "Director", lines: ["Tomás López Rojas", "Cirujano Dentista."] },
                { title: "Dirección", lines: ["El Conquistador N° 01565, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 6884", "oirscesfamcarlosgodoy@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves de 08:00 a 17:00 hrs.", "Viernes de 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la Atención",
                    lines: [
                        "Lunes a Jueves de 17:00 a 20:00 hrs",
                        "Viernes de 16:00 a 20:00 hrs.",
                        "Sábados de 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CESFAM Dr. Iván Insunza Bascuñán",
            blocks: withCesfamInfo([
                { title: "Director", lines: ["Petronila Andrea Llanos Cerna", "Enfermera"] },
                { title: "Dirección", lines: ["Mar de Chile Nº 491, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 61 82", "cesfam.ivaninsunzab@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves de 08:00 a 17:00 hrs.", "Viernes de 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la Atención",
                    lines: [
                        "Lunes a Jueves de 17:00 a 20:00 hrs",
                        "Viernes de 16:00 a 20:00 hrs.",
                        "Sábados de 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CESFAM El Abrazo Dr. Salvador Allende Gossens",
            blocks: withCesfamInfo([
                { title: "Director", lines: ["Pamela Muñoz Abarca", "Nutricionista."] },
                { title: "Dirección", lines: ["Cristo Redentor N°16975, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 8109"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a jueves: 08:00 a 17:00 hrs.", "Viernes: 08:00 a 16:00 hrs."]
                },
                {
                    title: "Continuidad de la atención",
                    lines: [
                        "Lunes a jueves: 17:00 a 20:00 hrs.",
                        "Viernes: 16:00 a 20:00 hrs.",
                        "Sábado: 09:00 a 19:00 hrs."
                    ]
                }
            ])
        },
        {
            title: "CECOSF Lumen",
            blocks: withCecosfInfo([
                { title: "Encargada", lines: ["Francisca Quintana Rodríguez.", "Matrona."] },
                { title: "Dirección", lines: ["Lumen N° 3756, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 84 03", "cecosflumen@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 16:00 hrs."]
                }
            ])
        },
        {
            title: "CECOSF Lo Errázuriz",
            blocks: withCecosfInfo([
                { title: "Encargada", lines: ["Yasna Belmar Saez", "Psicóloga."] },
                { title: "Dirección", lines: ["Av. Sur de Chile N° 4382, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 80 09", "cecosferrazuriz@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 16:00 hrs."]
                }
            ])
        },
        {
            title: "CECOSF Los Bosquinos",
            blocks: withCecosfInfo([
                { title: "Encargada", lines: ["María Alejandra Castillo", "Profesión: Enfermera."] },
                { title: "Dirección", lines: ["Av. El Tranque N° 175, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 87 19", "cecosflosbosquinoscg@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 16:00 hrs."]
                }
            ])
        },
        {
            title: "CECOSF Santiago Bueras",
            blocks: withCecosfInfo([
                { title: "Encargada", lines: ["Macarena Escobar Venegas", "Cirujana Dentista."] },
                { title: "Dirección", lines: ["Gral. Bueras N° 456, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 84 78", "cesfam.ivaninsunzab@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 14:00 hrs."]
                }
            ])
        },
        {
            title: "CECOSF Futramapu",
            blocks: withCecosfInfo([
                { title: "Encargado", lines: ["Mauricio Oyarce", "Enfermero."] },
                { title: "Dirección", lines: ["Calle Judea N° 321, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 8109"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 16:00 hrs."]
                }
            ])
        },
        {
            title: "CECOSF Europa",
            blocks: withCecosfInfo([
                { title: "Encargada", lines: ["Ignacia Vilches", "Enfermera."] },
                { title: "Dirección", lines: ["Europa N° 0220, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 6825"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves 8:00 a 17:00 hrs.", "Viernes 8:00 a 16:00 hrs."]
                }
            ])
        },
        {
            title: "COSAM (Centros Comunitario de Salud Mental Familiar)",
            blocks: [
                { title: "Encargada", lines: ["Paola Arellano Quezada", "Enfermera."] },
                { title: "Dirección", lines: ["Av. Libertador Bernardo O'Higgins, N° 1000, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 402 80 28", "cosam@maipu.cl"] },
                { title: "Horarios de atención", lines: ["Lunes a Viernes de 8:00 a 17:00 hrs."] }
            ]
        },
        {
            title: "SAPU Dr. Iván Insunza",
            blocks: [
                { title: "Directora", lines: ["Petronila Andrea Llanos Cerna", "Enfermera"] },
                { title: "Dirección", lines: ["Mar de Chile Nº 491, Maipú."] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 61 82"] },
                {
                    title: "Horarios de atención",
                    lines: [
                        "Lunes a Jueves 17:00 a 24:00 hrs.",
                        "Viernes 16:00 a 24:00 hrs",
                        "Sábados, domingo y festivos 8:00 a 24:00 hrs"
                    ]
                }
            ]
        },
        {
            title: "SAR Servicios de Atención Primaria de Urgencia de Alta Resolución",
            blocks: [
                { title: "Coordinadora", lines: ["Raquel Villavicencio Carrasco", "Enfermera con Mención en Urgencia UDD"] },
                { title: "Dirección", lines: ["Av. Nueva San Martín N° 779, Maipú"] },
                { title: "Contacto", lines: ["Teléfono OIRS: 22 677 68 25", "cesfam.mbachelet@gmail.com"] },
                {
                    title: "Horarios de atención",
                    lines: [
                        "Lunes a Jueves de 17:00 a 08:00 Hrs.",
                        "Viernes de 16:00 a 08:00 Hrs.",
                        "Sábados, domingo y festivos las 24 hrs."
                    ]
                }
            ]
        },
        {
            title: "CREAP Centro de Resolutividad de Atención Primaria",
            blocks: [
                { title: "Coordinador", lines: ["Daniel Busto Salazar", "Tecnólogo médico"] },
                { title: "Dirección", lines: ["Avda. 5 de Abril N° 1150, Maipú"] },
                {
                    title: "Horarios de atención",
                    lines: ["Lunes a Jueves de 08:00 a 17:00 hrs.", "Viernes de 08:00 a 16.00 horas."]
                },
                {
                    title: "Continuidad de la Atención",
                    lines: [
                        "Mamografía y Sala UAPO",
                        "Lunes a Jueves de 17:00 a 19:00 hrs",
                        "Viernes de 16:00 a 19:00 hrs.",
                        "Sábados de 09:00 a 13:00 hrs."
                    ]
                }
            ]
        }
    ];

    private isLink(line: string) {
        return line.indexOf("http") === 0 || line.indexOf("www.") === 0;
    }

    private openLine(line: string) {
        if (!this.isLink(line)) {
            return;
        }

        const url = line.indexOf("http") === 0 ? line : `https://${line}`;
        this.toLink(url, 1);
    }

    private toLink(item: string, blank: number) {
        if (item && item !== "") {
            if (blank === 1) {
                window.open(item, "_blank");
            } else {
                window.open(item, "_self");
            }
        }
    }
}
